import { useEffect } from "react";

export default function Helmet({ title, children }) {
    useEffect(() => {
        if (title) document.title = title;

        return () => {
            // Cleanup (optional)
        };
    }, [title]);
    return children || null;
}